import { render, staticRenderFns } from "./BuyCredits.vue?vue&type=template&id=6c28962e&"
import script from "./BuyCredits.vue?vue&type=script&lang=js&"
export * from "./BuyCredits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports